// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YTzf","inner":"Footer_inner__2KPSG"};